import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import type { IContextualMenuClassNames } from "@1js/acui-common";

export const getMLRMenuClassNames = memoizeFunction(
  (
    customMenuClassNames?: IContextualMenuClassNames
  ): IContextualMenuClassNames => {
    return {
      ...mergeStyleSets(
        {
          container: { paddingTop: 0 },
          list: {},
          header: {
            height: 28,
            lineHeight: 28,
            fontSize: 12,
          },
          root: {},
          title: {},
        },
        customMenuClassNames
      ),
      subComponentStyles: { menuItem: {}, callout: {} },
    };
  }
);

export const getMLRControlGroupMenuClassNames = memoizeFunction(
  (): IContextualMenuClassNames => {
    return {
      ...mergeStyleSets({
        container: {},
        list: {},
        header: {},
        root: { padding: "1px 5px 0px 5px" },
        title: {},
      }),
      subComponentStyles: { menuItem: {}, callout: {} },
    };
  }
);
